import { Button, Input, TextArea } from '@ui';
import React, { FC, ReactNode, useEffect, useState } from 'react';

import { LoadingIcon } from '@app/components/ui/icons/icons-list';

import Icon from '@app/components/ui/icons';

import {
  AllChanelsArrType,
  MetricListArrType,
} from '@app/interfaces/pages-types/anatylics-metric.type';
import {
  GPTGroupMetricListObjectType,
  GPTGroupObjectType,
  GptGroupTestResultType,
  IndividualGptMetricType,
} from '@app/interfaces/gpt-metric.type';

import { gptMetricCodeTranslate } from '@app/constants/gpt-metric-code-translate';

import { LazyQueryTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import {
  QueryDefinition,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';

import { OptionItem } from '@app/components/ui/select/select.type';

import {
  GPTGroupChatObjectType,
  GPTGroupMetricListChatObject,
} from '@app/interfaces/gpt-metric-chats.type';

import { ChatRoleSettingsType } from '@app/interfaces/chat-roles-settings.type';

import { GetFilterParams } from '@app/pages/last-project-records/last-project-records.page';

import AiMetricTestingTable from './ai-metric-testing-table';
type AiMetricTestingModalPropsType = {
  onCloseModal(): void;
  setStep: React.Dispatch<React.SetStateAction<1 | 2>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  step: 1 | 2;
  voiceMetricList: MetricListArrType[] | undefined;
  gpt_metrics:
    | GPTGroupMetricListObjectType['gpt_groups']
    | GPTGroupMetricListChatObject['gpt_groups'];
  group?: GPTGroupObjectType | GPTGroupChatObjectType;
  currentMetricsDataFromGroup:
    | ({
        metric_id: string;
      } & IndividualGptMetricType)[]
    | undefined;
  channels: AllChanelsArrType[];
  currentData: GptGroupTestResultType | undefined;
  testMetric:
    | LazyQueryTrigger<
        QueryDefinition<
          {
            gpt_group_id: string;
            record_id?: string;
          },
          BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
          'gptGroupsList' | 'gptGroupSingle',
          GptGroupTestResultType,
          'gptMetricApi'
        >
      >
    | LazyQueryTrigger<
        QueryDefinition<
          {
            gpt_group_id: string;
            chat_id?: string;
          },
          BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
          'gptGroupsChatList' | 'gptChatGroupSingle',
          GptGroupTestResultType,
          'gptMetricChatApi'
        >
      >;
  modelsOptions: OptionItem[];
  currentTemplate: 'chat' | 'voice';
  chatRoles?: ChatRoleSettingsType[];
};
const DEFAULT_FILTER_SETUP: GetFilterParams = {
  offset: 0,
  limit: 10,
  filter: {
    range: {
      type: 'n',
      parameters: [],
    },
    filter: [],
  },
};
const AiMetricTestingModal: FC<AiMetricTestingModalPropsType> = (props) => {
  const {
    onCloseModal,
    setStep,
    step,
    modelsOptions,
    setLoading,
    loading,
    voiceMetricList,
    gpt_metrics,
    group,
    channels,
    currentMetricsDataFromGroup,
    currentData: metric_results,
    testMetric,
    currentTemplate,
    chatRoles,
  } = props;

  const [currentData, setCurrentData] = useState(metric_results);
  const [filterParams, changeFilterParams] = useState<GetFilterParams>(DEFAULT_FILTER_SETUP);

  useEffect(() => {
    setCurrentData(metric_results);
  }, [metric_results]);
  function handleChangeStep(curStep: 1 | 2) {
    setStep(curStep);
  }

  const filterKeys = (function getFilteringKeys() {
    const gptMetrics = gpt_metrics.flatMap((group) => group.gpt_metrics) || [];

    return [...(voiceMetricList || []), ...(gptMetrics || [])]?.map((metric) => ({
      id: metric.metric_id,
      title: metric.name,
      type_value: metric.result_value_type,
    }));
  })();

  const contentRenderByStep: Record<1 | 2, ReactNode> = {
    1: (
      <AiMetricTestingTable
        filterParams={filterParams}
        changeFilterParams={changeFilterParams}
        filterKeys={filterKeys}
        handleChangeStep={handleChangeStep}
        onCloseModal={onCloseModal}
        group={group}
        setLoading={setLoading}
        testMetric={testMetric}
      />
    ),
    2: (
      <div className="flex flex-col gap-[32px]">
        {/* 1 */}
        <div className="flex flex-col gap-[18px]">
          <span className="text-[24px] font-bold text-0color">Применённые настройки группы</span>
          <div className="grid grid-rows-1 grid-cols-[350px_748px] gap-x-[18px]">
            <div className="flex flex-col gap-[18px]">
              <Input
                disabled
                defaultValue={
                  modelsOptions.find(
                    (model) => model.value === group?.settings.gpt_integration.gpt_integration_id,
                  )?.title || 'N/A'
                }
                label="Модель"
              />
              {currentTemplate === 'chat' ? (
                <Input
                  disabled
                  defaultValue={
                    chatRoles?.find(
                      (c) => c.crole_id === (group as GPTGroupChatObjectType)?.settings.c_role,
                    )?.name || 'N/A'
                  }
                  label="Роль"
                />
              ) : (
                <Input
                  disabled
                  defaultValue={
                    channels.find(
                      (c) =>
                        c.settings_channels_id === (group as GPTGroupObjectType)?.settings.channel,
                    )?.name || 'N/A'
                  }
                  label="Канал"
                />
              )}
            </div>
            <div className="flex flex-col gap-[18px]">
              <TextArea
                height={71}
                defaultValue={currentData?.request?.prompt?.reduce(
                  (acc, cur) => acc + cur.content,
                  '',
                )}
                label="Промпт группы GPT-метрик"
                popupModal
              />
              <TextArea
                defaultValue={
                  typeof currentData?.result?.raw_response !== 'string'
                    ? currentData?.result?.raw_response?.choices?.reduce(
                        (acc, cur) => acc + cur.message.content,
                        '',
                      )
                    : ''
                }
                height={71}
                label="Полный ответ GPT"
                popupModal
              />
            </div>
          </div>
        </div>
        {/* 1 */}
        {/* 2 */}
        <div className="flex flex-col gap-[18px]">
          <span className="text-[24px] font-bold text-0color">Результаты метрик</span>
          {currentData?.result?.data?.map((metricRes) => {
            const currentMetric = currentMetricsDataFromGroup?.find(
              (metric) => metric.metric_id === metricRes.metric_id,
            );

            return (
              <MetricResultField
                key={metricRes.metric_id}
                label={currentMetric?.name || 'N/A'}
                fields={[
                  {
                    key: 'Формат',
                    label: 'Формат',
                    value:
                      currentMetric?.result_value_type === 'num'
                        ? 'Число'
                        : currentMetric?.settings.str_validation === 'text'
                        ? 'Строка'
                        : 'Текст',
                  },
                  {
                    key: 'Значение метрики',
                    label: 'Значение метрики',
                    value:
                      typeof metricRes.value !== 'number' && typeof metricRes.value !== 'string'
                        ? 'null'
                        : metricRes.value,
                  },
                  {
                    key: 'Ответ  GPT',
                    label: 'Ответ  GPT',
                    value:
                      typeof metricRes.raw_value !== 'number' &&
                      typeof metricRes.raw_value !== 'string'
                        ? 'null'
                        : metricRes.raw_value,
                  },
                ]}
                status={{
                  message: gptMetricCodeTranslate[metricRes.cases.code] || 'null',
                  result: metricRes.cases.code === 200 ? 'ok' : 'error',
                }}
              />
            );
          })}
        </div>
        {/* 2 */}
        <div className="sticky bg-white bottom-0 pb-[24px]  flex w-full items-center justify-between">
          <Button fill="linked" label="Повторить тест" onClick={() => handleChangeStep(1)} />
          <Button onClick={onCloseModal} label="Вернуться в настройки" />
        </div>
      </div>
    ),
  };

  return (
    <div className="px-[24px] relative">
      <>
        {loading ? (
          <div className="py-8 flex items-center flex-col justify-center gap-[100px]">
            <LoadingIcon size={100} />
            <span className="text-center font-medium text-[14px] text-4color mt-[4px]">
              Мы проводим процесс тестирования - подождите совсем немного!
            </span>
          </div>
        ) : (
          contentRenderByStep[step]
        )}
      </>
    </div>
  );
};

export default AiMetricTestingModal;

export const MetricResultField: FC<{
  label: string;
  fields: { key: string; label: string; value: string | number }[];
  status?: { message: string; result: 'ok' | 'error' };
}> = ({ label, fields, status }) => {
  const grid = fields
    .map((_, index) => {
      if (index === fields.length - 1) return '1fr';
      return '200px';
    })
    .join(' ');

  return (
    <div className="p-[18px] bg-defaultBg flex flex-col gap-[18px] rounded-defaultR">
      <span className="text-[20px] font-bold text-0color">{label}</span>
      <div className="grid grid-rows-1 gap-x-[18px] " style={{ gridTemplateColumns: grid }}>
        {fields.map((field, index) =>
          field.key === 'Ответ  GPT' ? (
            <Input
              key={field.key + index}
              label={field.label}
              defaultValue={field.value}
              popupModal
            />
          ) : (
            <Input key={field.key + index} label={field.label} defaultValue={field.value} />
          ),
        )}
      </div>
      {status && (
        <div
          style={{
            borderColor: status.result === 'ok' ? '#00da57' : '#fb3a3a',
            backgroundColor: status.result === 'ok' ? '#e0ffed' : '#fef2f2',
          }}
          className="border-solid border-[1px] p-[22px_20px] flex items-center justify-start font-normal text-[16px] text-0color leading-[125%] rounded-[12px] gap-[4px]"
        >
          <div
            className="p-1 flex items-center justify-center rounded-full"
            style={{ backgroundColor: status.result === 'ok' ? '#00da57' : '#fb3a3a' }}
          >
            <Icon
              size={7}
              className="!text-white "
              name={status.result === 'ok' ? 'CheckIcon' : 'XIcon'}
            />
          </div>
          {status.message}
        </div>
      )}
    </div>
  );
};
